export const configuration = (
  baseUrl: string,
  fetchWithAuth: (url: string, options?: RequestInit) => Promise<Response>
) => {
  return {
    /**
     * Get metadata.
     * @returns
     */
    metadata: async () => {
      const url = `${baseUrl}/Metadata`;
      const response = await fetchWithAuth(url);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      console.debug('configuration.metadata response', data);
      return data;
    },

    /**
     * Get metadata info.
     * @returns
     */
    metadataInfo: async () => {
      const url = `${baseUrl}/Metadata/Info`;
      const response = await fetchWithAuth(url);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      console.debug('configuration.metadata info response', data);
      return data;
    },

    /**
     * Get configuration data as JSON string.
     * @returns
     */
    load: async () => {
      const url = `${baseUrl}/Load`;
      const response = await fetchWithAuth(url);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      console.debug('configuration.load response', data);
      return data;
    },

    /**
     * Save configuration data as JSON string.
     * @param data Configuration data as JSON string
     * @returns
     */
    save: async (data: string) => {
      const url = `${baseUrl}/Save`;
      const response = await fetchWithAuth(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ data })
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const result = await response.json();
      console.debug('configuration.save response', result);
      return result;
    }
  };
};
